export const SubCategoryColumns = [
  {
    id: "actions",
    title: "Actions",
  },
  {
    id: "category_id",
    title: "Category",
  },
  {
    id: "name",
    title: "Name",
  },
];
